"use strict";
var _ = require("lodash");
var oAuthUtils_1 = require("../utils/oAuthUtils");
var VkIdUtils = (function () {
    function VkIdUtils() {
    }
    /** Осуществляет авторизацию через VK ID */
    VkIdUtils.authorize = function (clientId, redirectUri, returnUrl) {
        if (returnUrl === void 0) { returnUrl = null; }
        if (returnUrl)
            VkIdUtils.setCookie('VkId.ReturnUrl', returnUrl);
        else
            VkIdUtils.setCookie('VkId.ReturnUrl', '');
        var verifier = oAuthUtils_1.default.generateRandomString();
        var state = oAuthUtils_1.default.generateRandomString();
        VkIdUtils.setCookie('VkId.Verifier', verifier);
        VkIdUtils.setCookie('VkId.State', state);
        oAuthUtils_1.default.challenge_from_verifier(verifier, function (codeChallenge) {
            var query = '?response_type=code'
                + '&client_id=' + clientId
                + '&redirect_uri=' + redirectUri
                + '&state=' + state
                + '&code_challenge=' + codeChallenge
                + '&code_challenge_method=S256'
                + '&scope=email';
            location.assign('https://id.vk.ru/authorize' + query);
        });
    };
    /** Установка cookie на 60 секунд */
    VkIdUtils.setCookie = function (name, value) {
        if (value)
            document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=60;';
        else
            document.cookie = name + '=0; path=/; max-age=0;';
    };
    return VkIdUtils;
}());
_.extend(window["AppUtils"], {
    VkId: VkIdUtils
});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = VkIdUtils;
//# sourceMappingURL=vkIdUtils.js.map